import * as React from 'react';
import { Modal, Button } from 'semantic-ui-react';

export interface ConfirmationProps {
  show: boolean;
  message?: string;
  confirmButtonText?: string;
  positive?: boolean;
  negative?: boolean;

  onConfirm(): void;
  onCancel(): void;

}

export class Confirmation extends React.Component<ConfirmationProps, {}> {

  render() {
    const { message, onConfirm, onCancel, confirmButtonText,
      show, positive, negative } = this.props;
    return (
      <Modal onClose={onCancel} closeOnEscape={true} open={show} size="tiny">
        <Modal.Content>
          <div className="confirmation">
            <div className="confirmationText">
              {message || 'Are you sure?'}
            </div>
            <div className="confirmationActions">
              <Button
                onClick={onCancel}
                circular={true}
                basic={true}
                color="blue"
                id="confirmationCancel"
              >
                Nevermind
              </Button>
              <Button
                primary={positive}
                onClick={onConfirm}
                negative={negative}
                circular={true}
              >
                {confirmButtonText || 'Confirm'}
              </Button>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}







// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MessageItem/Confirmation.tsx